import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  ContainerButton,
  Content,
  Dialog,
  Header,
  Loader,
  ErrorMessage,
} from './styles';

const ExportDialog = (props) => {
  const {
    show,
    handleClose,
    loadingExport,
    downloadExport,
    errorExport,
  } = props;

  const handleCloseModal = (e) => {
    handleClose(e);
  };
  return (
    <Dialog
      open={show}
      closeOnEscape
      onClose={handleCloseModal}
    >
      <Content>
        {
          loadingExport && (
            <>
              <Header>Hang tight! We&apos;re processing your export</Header>
              <Loader size="large" data-loader="export-loader" />
            </>
          )
        }
        {
          ((!loadingExport && !errorExport)) && (
            <>
              <Header>Your export is ready</Header>
              <ContainerButton>
                <Button
                  data-download-export
                  onClick={downloadExport}
                >
                  Download
                </Button>
              </ContainerButton>
            </>
          )
        }
        {
          (errorExport) && (
            <ErrorMessage>There was an issue with the download template. Please contact support.</ErrorMessage>
          )
        }
      </Content>
    </Dialog>
  );
};

ExportDialog.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  loadingExport: PropTypes.bool.isRequired,
  downloadExport: PropTypes.func.isRequired,
  errorExport: PropTypes.bool.isRequired,
};

ExportDialog.defaultProps = {
  show: false,
};

export default ExportDialog;
